module.exports = __webpack_public_path__ + "static/media/driver@1.64300546.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/images/driver@1.jpg
// module id = 100
// module chunks = 0